import { css } from '@emotion/react';

export const adminHeaderCSS = () => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 24px;
    border-bottom: 1px solid var(--pei-line-soft);
    background: #fff;
    font-family: var(--pei-font);

    .ah-left {
        display: flex;
        align-items: center;
        gap: 14px;
        min-width: 0;
    }

    .ah-hamburger {
        display: none;
        width: 36px;
        height: 36px;
        align-items: center;
        justify-content: center;
        border: none;
        background: transparent;
        border-radius: 8px;
        color: var(--pei-text-label);
        cursor: pointer;
        padding: 0;

        i {
            font-size: 18px;
        }

        &:hover {
            background: var(--pei-bg-soft);
        }

        &:focus-visible {
            outline: none;
            box-shadow: 0 0 0 2px rgba(52, 198, 241, 0.25);
        }
    }

    @media (max-width: 1023px) {
        .ah-hamburger {
            display: inline-flex;
        }
    }

    .ah-logo {
        height: 28px;
        width: auto;
        display: block;
        flex-shrink: 0;
        object-fit: contain;
    }

    .ah-logo-link {
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
        line-height: 0;
        border-radius: 6px;

        &:focus-visible {
            outline: 2px solid var(--pei-cyan, #32B8DF);
            outline-offset: 3px;
        }
    }

    .ah-logo--compact {
        height: 26px;
    }

    .ah-divider {
        width: 1px;
        height: 18px;
        background: var(--pei-line);
    }

    .ah-page-title {
        font-size: 14px;
        color: var(--pei-text-helper);
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ah-right {
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;
    }

    .ah-bell-slot {
        display: inline-flex;

        .ab-trigger {
            width: 36px;
            height: 36px;
            font-size: 1.05rem;
        }
    }

    .ah-profile {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 4px 12px 4px 4px;
        border-radius: var(--pei-radius-pill);
        background: var(--pei-bg-soft);
        border: 1px solid var(--pei-line-soft);
        font-family: inherit;
        color: inherit;
        cursor: pointer;
        text-align: left;
        transition: background 120ms ease, border-color 120ms ease;

        &:hover {
            background: #EEF1F4;
            border-color: var(--pei-line);
        }

        &:focus-visible {
            outline: none;
            box-shadow: 0 0 0 2px rgba(52, 198, 241, 0.25);
        }
    }

    .ah-avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: linear-gradient(135deg, #34C6F1, #00BA6E);
        display: grid;
        place-items: center;
        color: #fff;
        font-weight: 700;
        font-size: 12px;
    }

    .ah-profile-meta {
        font-size: 12px;
        line-height: 1.2;
    }

    .ah-name {
        font-weight: 600;
        color: var(--pei-text);
    }

    .ah-role {
        color: var(--pei-text-helper);
    }
`;
